import { Exclude, Expose } from "class-transformer";
import { IsDate, IsDefined, IsString } from "class-validator";

import { TransformToDate } from "../transformers/transformToDate";

@Exclude()
export class HyperwalletInformation {
    @IsString()
    @IsDefined()
    @Expose()
    public token: string;

    @IsDate()
    @IsDefined()
    @TransformToDate
    @Expose()
    public createdOn: Date;

    @IsString()
    @IsDefined()
    @Expose()
    public verificationStatus: string;

    @IsString()
    @IsDefined()
    @Expose()
    public profileType: string;

    @IsString()
    @IsDefined()
    @Expose()
    public taxVerificationStatus: string;

    @IsString()
    @IsDefined()
    @Expose()
    public status: string;

    @IsDate()
    @TransformToDate
    @Expose()
    public latestWebhookNotificationDate?: Date;
}
